export const user = (state) => state.user
export const googleOAuthUrl = (state) => state.googleOAuthUrl
